<template>
  <!-- 聊天页面 -->
  <div id="ask-chat">
    <div class="top-title">
      <img
        src="../../assets/img/login-img/3-1档案-返回ic@2x.png"
        alt=""
        class="back-icon"
        @click="goBack"
      >
      <p class="title-text">问诊咨询</p>
    </div>
    <div class="scroll-wrapper" ref="chatScrollRef">
      <div>
        <div class="chat-wrapper" ref="box" v-if="orderDetail">
          <div class="order-box">
            <div class="order-title">
              <span>咨询单号：{{orderDetail.order_number}}</span>
              <span
                v-show="orderDetail.trade_status == 1"
                @click.once="cancelOrder"
                :class="{cancelActive:cancelActive}"
              >取消订单</span>
            </div>
            <div class="order-content">
              <span class="order-time">{{orderDetail.create_time}}</span>
              <div class="order-person">
                <span>{{orderDetail.name}}</span>
                <span>{{orderDetail.sex}}</span>
                <span>{{orderDetail.age}}</span>
              </div>
              <span
                class="order-question"
                v-if="orderDetail.ask_first"
              >{{orderDetail.ask_first.question}}</span>
            </div>
          </div>
          <div class="chat-tips">
            <span>温馨提示：在线咨询不能代替面诊，医生建议仅供参考。</span>
          </div>
          <div class="chat-text">
            <ul class="text-box" ref="chatBox">
              <li
                class="text-item"
                v-if="index>0"
                v-for="(item, index) in textArray"
                :key="index"
                :class="{userInfo: item.type !=='2'}"
              >
                <!-- <span class="chat-time">{{timestampToTime(item.add_time)}}</span> -->
                <span class="chat-time">{{item.add_time|timeFilter}}</span>
                <div class="chat-item-box">
                  <img :src="item.doctor_image" alt="" class="doctor-icon" v-if="item.type ==='2'">
                  <!-- <img src="../../assets/img/askdoctor/QJ6724675861 @2x.png" alt="" class="doctor-icon" v-if="item.type ==='2'"> -->

                  <div class="item-right">
                    <div class="item-name" v-if="item.type ==='2'">
                      <span>{{item.doctor_name}}</span>
                      <img
                        src="../../assets/img/askdoctor/famous@2x.png"
                        v-if="item.is_famous_doctor"
                        alt=""
                        class="famous"
                      >
                    </div>
                    <div class="bgc-wrapper">
                      <p class="text-info" v-html="item.question">{{item.question}}</p>
                      <div class="img-wrapper">
                        <img
                          class="text-img"
                          ref="imgRef"
                          @click="seeImg(item.path_url)"
                          v-if="item.ask_type === '2'"
                          :src="item.path_url"
                          alt=""
                          id="img"
                        >
                      </div>
                      <div class="audio-wrapper" v-if="item.ask_type === '3'" @click="playAudio">
                        <audio
                          controls="controls"
                          @click="playAudio"
                          ref="audioRef"
                          :src="item.path_url"
                          class="audio-box"
                        ></audio>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- <li id="flag">{{chatText}}</li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      class="chat-bottom"
      @click="isDisabled"
      v-if="orderDetail && !(orderDetail.trade_status === '2')"
    >
      <!-- 要是有压缩图片组件 注释掉不压缩上传即可 -->
      <div class="uploader-wrapper">
        <!-- 压缩图片 -->
        <upload ref="imageUpload" :isNeedPreview="false">
          <img slot="input" src="../../assets/img/askdoctor/file.png" alt="" class="pic-icon">
        </upload>
        <!-- 上传不压缩的图片 -->
        <!-- <template>
          <input
            type="file"
            ref="upImgRef"
            accept="image/*"
            class="up-img"
            value=""
            style="opacity:0;width:100%;height:100%;position:absolute;top:0;left:0"
            @change="upLoadNozip"
          >
          <img src="../../assets/img/askdoctor/file.png" alt="" class="pic-icon" @click="upImg">
        </template>-->
      </div>
      <img
        src="../../assets/img/see-doctor-icon/send-comment.png"
        @click="sendText"
        alt=""
        class="comment-icon"
      >
      <input
        :disabled="!hasReply"
        ref="inputSend"
        placeholder="追问医生~"
        @blur="sendImg = false"
        @focus="onFocus"
        type="text"
        class="chat-input"
        @keypress.enter="sendText"
        v-model="inputText"
      >
    </div>
    <van-button
      v-if="orderDetail &&(orderDetail.trade_status==='2')"
      @click="goComment"
      class="comment-button"
      type="primary"
    >{{commentButton}}</van-button>
    <!-- 弹出评价 -->
    <div class="comment-box" v-if="showComment">
      <div class="pop-wrapper" position="center" :overlay="true">
        <div class="pop-box">
          <div class="pop-icon">
            <img
              :src=" orderDetail.doctor_image ||orderDetail.xz_doctor_image"
              alt=""
              class="doctor-icon"
            >
            <div class="doctor-box">
              <span class="doctor-name">{{orderDetail.doctor_name || orderDetail.xz_doctor_name}}</span>
              <img
                v-if="orderDetail.if_famous"
                src="../../assets/img/askdoctor/famous@2x.png"
                alt=""
                class="famous"
              >
            </div>
          </div>
          <div class="pop-star">
            <van-rate v-model="starValue" :size="35" @change="getStarValue"/>
          </div>
          <div class="pop-comment">
            <ul class="comment-wrapper">
              <li
                class="comment-item"
                :class="{activeComment: keyList.includes(value)}"
                v-for="(key,value) in commentLIst"
                :key="key"
              >
                <span class="comment text" @click="checkComment(value)">{{key}}</span>
              </li>
            </ul>
          </div>
          <van-button type="primary" class="pop-button" @click="pushComment">提交</van-button>
        </div>
        <div
          class="pop-close"
          :class="{'v-level-active':showComment}"
          @click="showComment = false"
          v-if="showComment"
        >
          <img src="../../assets/img/payimg/closePay.png" alt="" class="close-icon">
        </div>
      </div>
    </div>
    <!-- 查看评价 -->
    <div class="comment-box" v-if="seeComment">
      <div class="pop-wrapper" position="center" :overlay="true">
        <div class="pop-box">
          <div class="pop-icon">
            <img
              :src=" orderDetail.doctor_image ||orderDetail.xz_doctor_image"
              alt=""
              class="doctor-icon"
            >
            <div class="doctor-box">
              <span class="doctor-name">{{orderDetail.doctor_name || orderDetail.xz_doctor_name}}</span>
              <img
                v-if="orderDetail.if_famous"
                src="../../assets/img/askdoctor/famous@2x.png"
                alt=""
                class="famous"
              >
            </div>
          </div>
          <div class="pop-star">
            <van-rate v-model="starValue" :size="35" @change="getStarValue"/>
          </div>
          <div class="pop-comment">
            <ul class="comment-wrapper">
              <!-- <li class="comment-item" :class="{activeComment: keyList.includes(value)}" v-for="(key,value) in isCommentData.zh_assess_info.tag_keys" :key="key"> -->
              <li
                class="comment-item activeComment"
                v-if="isCommentData"
                :class="{activeComment: keyList.includes(value)}"
                v-for="(key,value) in isCommentData.zh_assess_info.tag_keys"
                :key="key"
              >
                <span class="comment text" @click="checkComment(value)">{{key}}</span>
              </li>
            </ul>
          </div>
          <!-- <van-button type="primary" class="pop-button" @click="pushComment">提交</van-button> -->
        </div>
        <div
          class="pop-close"
          :class="{'v-level-active':showComment}"
          @click="seeComment = false"
          v-if="seeComment"
        >
          <img src="../../assets/img/payimg/closePay.png" alt="" class="close-icon">
        </div>
      </div>
    </div>
    <!-- end -->
    <!--  -->
    <!-- 蒙层 -->
    <div v-if="showMongolia" class="mongolia" @click="closeMongolia"></div>
  </div>
</template>

<script>
  // import voice from '../../components/public/voice'
  // import eventBus from '../../common/eventBus.js'
  import BScroll from "better-scroll";
  import upload from "@/components/public/imageUpload";
  // import wx from "weixin-js-sdk";
  import api from "@/api/index";
  import { ImagePreview } from 'vant';
  export default {
    data() {
      return {
        showComment: false,
        starValue: 5, // 评论星星数量
        inputText: "",
        socket: null,
        fileTag: "",
        imgs: [],
        orderNumber: "",
        orderDetail: null,
        json: "",
        textArray: [],
        text: {},
        commentData: [],
        // commentLIst: [],
        starNum: 5,
        level: "best",
        keyList: [],
        doctorId: "",
        localText: [],
        doctorName: null,
        doctorImg: null,
        sendImg: false,
        cancelActive: false,
        hasReply: false,
        seeComment: false,
        isComment: null,
        isCommentData: null,
        iosBottom: null, // 用来控制ios输入框跟随页面提升的定时器
        chatScroll: null,
        replyType: null,
        showMongolia: false, // 控制透明蒙层的显示
        cancelOrderTimer: null, // 异步获取订单状态
        sendFlag: true // 发送信息的节流开关
      };
    },
    components: {
      upload
    },
    beforeMount() {
      if (this.$route.query.orderId) {
        this.orderNumber = this.$route.query.orderId;
      }
    },
    beforeRouteLeave(to, from, next) {
      if (to.path === "/SdInquiry") {
        this.$router.replace("/SdAskDoctor");
        next();
      } else {
        next();
      }
    },
    beforeDestroy() {
      if (this.cancelOrderTimer) {
        clearInterval(this.cancelOrderTimer);
      }
    },
    mounted() {
      // 进去之后清空未读提示
      this.clearNum();
      // 判断是否有回复 取消聊天输入禁用
      this.isReply();
      // this.$nextTick(() => {
      this.fetch();
      // })
      // document.body.scrollTop = (0, 10)
    },
    destroyed() {
      // clearTimeout(this.iosBottom)
      clearInterval(this.iosBottom);
    },
    watch: {
      chatText: {
        handler(n, o) {
          if (n.order_number === this.$route.query.orderId) {
            // 判断医生就回复的数据类型 与自己数据库返回的数据类型保持一致 便于输出
            if (n.data[0].type === "text") {
              this.replyType = "1";
            } else if (n.data[0].type === "image") {
              this.replyType = "2";
            } else if (n.data[0].type === "audio") {
              this.replyType = "3";
            }
            let params = {
              ask_type: this.replyType,
              question: n.data[0].text,
              type: "2",
              doctor_image: n.doctor_info.image,
              doctor_name: n.doctor_info.name,
              path_url: null
            };
            // this.replyType = '3'
            // let params = {
            //   ask_type: this.replyType,
            //   question: 'fdfdf',
            //   type: '2',
            //   doctor_image: n.doctor_info.image,
            //   doctor_name: n.doctor_info.name,
            //   path_url: ''
            // }
            if (this.replyType === "2" || this.replyType === "3") {
              params.question = "";
              params.path_url = n.data[0].file;
            }
            this.textArray.push(params);
            if (this.hasReply === false) {
              this.hasReply = true;
            }
            console.log(n, "医生回复");
            console.log(params, "websocke返回的数据");
            this.toBottom();
          }
        }
      },
      compressImgUrl: {
        // 如果获取到图片链接 上传该图片
        handler(n, o) {
          this.upDateImg(n);
        }
      },
      showMongolia: {
        handler(n, o) {
          if (n === false) {
            clearInterval(this.iosBottom);
          }
        }
      }
    },
    methods: {
      // 上传图片
      upDateImg(val) {
        let imgUrl = val;
        let params = {
          problem_id: this.orderDetail.problem_id,
          ask_group_id: this.orderDetail.ask_group_id,
          ask_type: "image",
          question: imgUrl
        };
        let url = "/consult/append_question";
        // console.log(val, "val");
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          // console.log(res, "res");
          if (res.data.code == 0) {
            let params = {
              type: "1",
              ask_type: "2",
              path_url: imgUrl,
              add_time: Number(new Date())
            };
            this.textArray.push(params);
            this.inputText = "";
            this.toBottom();
            setTimeout(() => {
              this.chatScroll.refresh();
            }, 1000);
            this.$refs.inputSend.blur();
          }
        });
      },
      // 打开选择图片
      uploadImg() {
        this.$refs.imageUpload.proxyClickInput();
      },
      // 不压缩上传图片 代理input。click事件
      upImg() {
        this.$refs.upImgRef.click();
      },
      // 上传不压缩的图片
      upLoadNozip(file) {
        console.log("我要上传图片；饿");
        let targetFile = file.target.files[0];
        // console.log(targetFile, 'targetFile')
        // 控制上传文件的大小为10m
        if (targetFile.size < 10 * 1000 * 1000) {
          let url = "/consult/upload";
          let formFile = new FormData();
          formFile.append("file", targetFile);
          this.$http.post(url, formFile).then(res => {
            console.log(res, "ress");
            if (res.data.error === 0) {
              let imgUrl = res.data.data.xdurl;
              // this.resultUrl = imgUrl\
              this.$refs.upImgRef.value = "";
              this.$store.dispatch("setImgUrl", imgUrl);
              console.log(imgUrl);
            } else {
              this.$toast(res.data.message);
              this.$refs.upImgRef.value = "";
            }
          });
        } else {
          const toast = this.$toast({
            mask: true,
            message: "图片太大了~",
            duration: 2000
          });
          this.$refs.upImgRef.value = "";
        }
      },
      goBack() {
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else {
          this.$router.go(-1);
          // this.$router.replace('/SdAskOrder')
        }
      },
      initWebSocket() {
        let that = this;
        this.$webSocket.onmessage = function(event) {
          // **接收到服务器数据**触发
          let res = JSON.parse(event.data);
          if (res.error === 0 && res.type === "reply") {
            that.getReplay(res);
          }
        };
      },
      onFocus() {
        this.showMongolia = true;
        if (this.orderDetail.status === "已完成") {
          this.$toast("订单已完成无法追问~");
        } else {
          this.iosBottom = setInterval(function() {
            document.body.scrollTop = document.body.scrollHeight;
          }, 300);
          this.sendImg = true;
        }
      },
      // 发送文本
      sendText() {
        if(this.orderDetail.trade_status == 3){
          this.$toast({
            message: '订单已取消，无法回复~',
            duration: 1500
          })
          return false
        }
        // 节流阀
        if (this.sendFlag) {
          this.sendFlag = false;
          let text = this.$trimStr(this.inputText);
          if (text === "") {
            this.inputText = "";
            this.$toast("不能输入空白信息");
            this.sendFlag = true;
          } else {
            if (this.judgeSend()) {
              let params = {
                problem_id: this.orderDetail.problem_id,
                ask_group_id: this.orderDetail.ask_group_id,
                ask_type: "text",
                question: this.utf16toEntities(this.inputText)
              };
              let url = "/consult/append_question";
              this.$http.post(url, this.$ObjToFd(params)).then(res => {
                console.log(res, "send text");
                if (res.data.code == 0) {
                  let params = {
                    type: "1",
                    ask_type: "1",
                    question: this.utf16toEntities(this.inputText),
                    add_time: Number(new Date())
                  };
                  this.textArray.push(params);
                  this.inputText = "";
                  this.toBottom();
                  this.$refs.inputSend.blur();
                  this.showMongolia = false;
                  this.sendFlag = true;
                }
              });
            }
          }
        } else {
        }
      },
      // 判断订单状态 已完成无法发送
      judgeSend() {
        if (this.orderDetail.status === "已完成") {
          this.$toast("订单已完成无法继续发送信息");
          this.inputText = "";
          return false;
        } else {
          return true;
        }
      },
      // 判断返回的数据类型（未使用 苹果上有bug）
      getExt(url) {
        if (!url) return;
        let ext = url.match(/.+\.([\d\w]+)$/);
        if (ext[1] === "") {
          return "0";
        } else if (ext[1] === "mp3") {
          return "2";
        } else if (ext[1] === "jpg" || ext[1] === "png") {
          return "1";
        }
      },
      // 获取订 单详情
      fetch() {
        let url = "/consult/consult_detail";
        let params = {
          order_number: this.orderNumber
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == "0") {
            this.orderDetail = res.data.data;
            // console.log(this.orderDetail, "this.orderDetail");
            this.textArray = res.data.data.list;
            if (this.textArray.length > 1) {
              this.$nextTick(() => {
                this.initScroll();
                this.toBottom();
              });
            }
            this.sendUid();
            this.judgeCommet();
            // this.textArray.map((item, index) => {
            //   this.getExt(item.path_url)
            // })
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // get replay
      getReplay(e) {
        let params = {
          question: e.data[0].text,
          type: "2",
          path_url: e.data[0].file
        };
        this.textArray.push(params);
      },
      toBottom() {
        this.$nextTick(() => {
          // eslint-disable-next-line
          let delay = setTimeout(() => {
            if (this.chatScroll.maxScrollY < 0) {
              this.chatScroll.refresh();
              this.chatScroll.scrollTo(0, this.chatScroll.maxScrollY);
              this.chatScroll.refresh();
            }
          }, 200);
        });
      },
      // 获取评价信息
      fetchCommet() {
        let url = "/consult/doctor_evaluate_list";
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.commentData = res.data.data;
          }
        });
      },
      // 弹出评价
      goComment() {
        // if (this.$refs.inputSend.disabled === false) {
        if (this.isComment) {
          this.getReplyComment();
        } else {
          this.showComment = true;
          this.fetchCommet();
        }
        // }
      },
      // 选择评价
      checkComment(value) {
        let n = this.keyList.indexOf(value);
        if (n > -1) {
          this.keyList.splice(n, 1);
        } else {
          this.keyList.push(value);
        }
      },
      // 提交评价
      pushComment() {
        let params = {
          level: this.level,
          tag_keys: this.keyList,
          problem_id: this.orderDetail.problem_id,
          doctor_id: this.orderDetail.doctor_id,
          start_num: this.starValue
        };
        let url = "/consult/doctor_evaluate";
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            this.$toast("评论成功");
            //this.$router.back(-1)
            this.$router.replace("/SdAskOrder");
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 获取评分
      getStarValue(val) {
        this.starNum = val;
        this.keyList = [];
        if (val === 1 || val === 2) {
          this.level = "bad";
        } else if (val === 3 || val === 4) {
          this.level = "good";
        } else {
          this.level = "best";
        }
      },
      // 取消订单
      cancelOrder() {
        this.cancelActive = true;
        let url = "/order/order_close";
        let params = {
          order_number: this.orderDetail.order_number
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0) {
            //this.$toast('取消成功', 2500)
            const toast = this.$toast({
              mask: true,
              message: "正在取消..."
            });
            this.cancelOrderTimer = setInterval(() => {
              this.$http.get(api.selectOrderStatus, { params }).then(res => {
                if (res.data.code == 0 && res.data.data.trade_status == 3) {
                  toast.clear();
                  this.$toast({ message: "取消成功", duration: 2000 });
                  this.$router.replace("/SdAskOrder");
                }
              });
            }, 1000);
          } else {
            this.$toast(res.data.message);
          }
        });
      },
      // 音频控制
      playAudio() {
        let ref = this.$refs.audioRef[0];
        ref.play();
      },
      // 清零
      clearNum() {
        let params = {
          order_number: this.orderNumber
        };
        let url = `/user/wdxx_clear?order_number=${params.order_number}`;
        this.$http.get(url).then(res => {});
      },
      // 时间戳转时间
      timestampToTime(timestamp) {
        let time = Date.now();
        let flag = timestamp || time;
        let date = new Date();
        if (flag.length === 10) {
          date = new Date(flag * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        } else if (flag.length === 13) {
          date = new Date(flag);
        }
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D = date.getDate() + " ";
        let h = date.getHours() + ":";
        let m = date.getMinutes() + ":";
        let s = date.getSeconds();
        return Y + M + D + h + m + s;
      },
      // 判断是否有医生回复
      isReply() {
        let url = "/order/check_reply";
        let params = {
          order_number: this.orderNumber
        };
        this.$http.post(url, this.$ObjToFd(params)).then(res => {
          if (res.data.code == 0 || res.data.code == "0") {
            this.hasReply = res.data.data;
          }
        });
      },
      // 禁用状态提示
      isDisabled() {
        if (this.$refs.inputSend.disabled === true) {
          this.$toast("请耐心等待医生回复~");
          if (event && event.preventDefault) {
            // 阻止默认浏览器动作(W3C)
            event.preventDefault();
          } else {
            // IE中阻止函数器默认动作的方式
            window.event.returnValue = false;
            return false;
          }
        }
      },
      // 发送uid 用来识别用户
      sendUid() {
        let json = `{"uid":1}`;
        this.$webSocket.send(json);
      },
      // 判断是否评价
      judgeCommet() {
        let params = {
          problem_id: this.orderDetail.problem_id
        };
        let url = `/consult/doctor_evaluate_has?problem_id=${params.problem_id}`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.isComment = res.data.data;
          }
        });
      },
      // 获取从新评价信息
      getReplyComment() {
        let params = {
          problem_id: this.orderDetail.problem_id
        };
        let url = `/consult/doctor_evaluate_detail?problem_id=${
          params.problem_id
        }`;
        this.$http.get(url).then(res => {
          if (res.data.code == 0) {
            this.seeComment = true;
            this.$nextTick(() => {
              this.isCommentData = res.data.data;
              this.starValue = this.isCommentData.start_num;
            });
          }
        });
      },
      // 初始化滚动
      initScroll() {
        let options = {
          click: true,
          prototype: 2
        };
        this.chatScroll = new BScroll(this.$refs.chatScrollRef, options);
      },
      // emoji
      utf16toEntities(str) {
        var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
        str = str.replace(patt, function(char) {
          var H, L, code;
          if (char.length === 2) {
            H = char.charCodeAt(0); // 取出高位
            L = char.charCodeAt(1); // 取出低位
            code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
            return "&#" + code + ";";
          } else {
            return char;
          }
        });
        return str;
      },
      // 预览图片 传到线上wx的api才用得了
      seeImg(val) {
        // wx.ready(() => {
        //   // let url = val
        //   wx.previewImage({
        //     // current: 'String', // 当前显示图片的链接，不填则默认为 urls 的第一张
        //     // current: 'http://test.shendutv.com/upload/chat/image/2018/11/30/2018113013415466390.jpeg',
        //     urls: [val],
        //     success: function(res) {
        //       // success
        //     },
        //     fail: function() {
        //       // fail
        //     },
        //     complete: function() {
        //       // complete
        //     }
        //   });
        // });
        ImagePreview([
          val
        ]);
      },
      // 点击蒙层输入框失去焦点
      closeMongolia() {
        // alert('111')
        // this.$refs.inputSend.blur()
        this.showMongolia = false;
        this.$refs.inputSend.onblur();
      }
      // 监听图片加载
    },
    computed: {
      commentLIst() {
        switch (this.starNum) {
          case 1:
            // this.commentLIst = this.commentData.bad
            return this.commentData.bad;
          case 2:
            // this.commentLIst = this.commentData.bad
            return this.commentData.bad;

          case 3:
            // this.commentLIst = this.commentData.good
            return this.commentData.good;
          case 4:
            // this.commentLIst = this.commentData.good
            return this.commentData.good;
          case 5:
            // this.commentLIst = this.commentData.best
            return this.commentData.best;
        }
      },
      commentButton() {
        if (this.isComment) {
          return "已评价，请大人查看~";
        } else {
          return "咨询完啦，求评价一下~";
        }
      },
      // vux 春雨医生后台返回的消息
      chatText() {
        return this.$store.state.chatStore.chatText;
        // retyu
      },
      // vuex 压缩图片组件完成之后返回的图片链接
      compressImgUrl() {
        return this.$store.state.utillStore.imgUrl;
      }
    },
    filters: {
      timeFilter(timestamp) {
        let time = Date.now();
        let flag = timestamp || time;
        let date = new Date();
        if (flag.length === 10) {
          date = new Date(flag * 1000); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        } else if (flag.length === 13) {
          date = new Date(flag);
        }
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D = date.getDate() + " ";
        let h = date.getHours() + ":";
        let m = date.getMinutes() + ":";
        let s = date.getSeconds();
        return Y + M + D + h + m + s;
        // return this.timestampToTime(val)
      }
    }
  };
</script>

<style lang="postcss">
  #ask-chat {
    background-color: #fffffd;
    height: 100%;
    /* position: absolute; */
    & .mongolia {
      height: 100%;
      width: 100%;
      /* background-color: red; */
      opacity: 0;
      /* z-index: 9999; */
      z-index: 5;
      position: absolute;
      /* top:0; */
    }
    & .top-title {
      width: 100%;
      padding: 27px 0;
      position: fixed;
      width: 100%;
      z-index: 999;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #fffffd;
      background-color: #fffffd;
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      & .back-icon {
        width: 17px;
        height: 34px;
        position: absolute;
        left: 30px;
      }
      & .title-text {
        font-size: 34px;
        font-family: "SourceHanSansCN Medium";
        font-weight: 400;
      }
    }
    & .scroll-wrapper {
      position: absolute;
      height: 100%;
      width: 100%;
      /* padding-bottom:88px; */
      overflow: hidden;
    }
    & .chat-wrapper {
      display: inline-block;
      width: 100%;
      /* height: 100%; */
      /* background-color: #fffffd; */
      margin-top: 75px;
      margin-bottom: 50px;
      overflow: hidden;
      /* box-sizing: border-box; */
      & .order-box {
        padding: 0 30px;
        & .order-title {
          padding: 0 30px;
          margin-top: 80px;
          display: flex;
          align-items: center;
          background: rgba(55, 189, 25, 1);
          border-radius: 10px 10px 0 0;
          display: flex;
          justify-content: space-between;
          font-size: 28px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          height: 80px;
        }
        & .order-content {
          padding: 26px 30px 30px 30px;
          display: flex;
          flex-direction: column;
          background: rgba(255, 255, 255, 1);
          box-shadow: 1px 0px 12px rgba(0, 0, 0, 0.1);
          border-radius: 0 0 10px 10px;
          & .order-time {
            font-size: 24px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
          & .order-person {
            margin: 20px 0;
            font-size: 30px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 800;
            color: rgba(51, 51, 51, 1);
            & span {
              margin-right: 20px;
            }
          }
          & .order-question {
            font-size: 30px;
            line-height: 35px;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            display: -webkit-box;
            text-overflow: ellipsis;
            /*! autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            overflow: hidden;
            -webkit-line-clamp: 10;
          }
        }
      }
      & .chat-tips {
        margin-top: 50px;
        display: flex;
        justify-content: center;
        font-size: 18px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(161, 202, 146, 1);
        & span {
          background: rgba(55, 189, 25, 0.05);
          border-radius: 25px;
          padding: 5px 10px;
        }
      }
      & .chat-text {
        margin-top: 40px;
        width: 100%;
        box-sizing: border-box;
        background-color: #fffffd;
        & .text-box {
          position: relative;
          padding: 0 30px;
          padding-bottom: 100px;
          & .chat-time {
            font-size: 20px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            width: 100%;
            display: flex;
            margin-bottom: 20px;
            justify-content: center;
            /* position: relative; */
            /* top: -30px; */
            position: absolute;
          }
          & .text-item {
            /* display: flex; */
            font-size: 30px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            position: relative;
            & .chat-item-box {
              display: flex;
              /* margin-top:50px; */
            }
            & .doctor-icon {
              height: 90px;
              width: 90px;
              margin-top: 30px;
            }
            & .bgc-wrapper {
              margin-top: 10px;
              background: rgba(51, 51, 51, 0.05);
              border-radius: 0 34px 34px 34px;
              padding: 20px 30px;
              /* width: 480px; */
              max-width: 480px;
              margin-bottom: 10px;
              position: relative;
              & .text-info {
                /* display: inline-block; */
                text-align: left;
                /* margin-top: 45px; */
              }
              & .text-img {
                /* background-color: red; */
                width: 100%;
                height: 100%;
              }
              & .audio-wrapper {
                /* width: 150px; */
                /* background-color: red; */
                height: 104px;
                overflow: hidden;
                & .audio-box {
                  /* width: 200px; */
                  /* position: relative; */
                  /* bottom: 35px; */
                  /* left: -40px; */
                  /* overflow: hidden; */
                }
              }
            }
            /* & .bgc-wrapper-audio {
                padding: 0.53333rem 0.8rem 0.53333rem 0;
                max-width: 13.6rem;
              } */
            & .item-right {
              margin-top: 30px;
              margin-left: 10px;
              & .item-name {
                display: flex;
                align-items: center;
                font-size: 22px;
                font-family: SourceHanSansCN-Medium;
                font-weight: 500;
                color: rgba(153, 153, 153, 1);
                & .famous {
                  width: 38px;
                  height: 22px;
                  margin-left: 10px;
                }
              }
            }
          }
          & .userInfo {
            /* width: 100%; */
            /* position: absolute !important; */
            /* background-color: red; */
            display: flex;
            text-align: right;
            flex-direction: row-reverse;
            & .bgc-wrapper {
              padding-top: 20px;
              background: rgba(183, 242, 189, 1);
              border-radius: 34px 0 34px 34px !important;
            }
          }
        }
      }
    }
    & .chat-bottom {
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      width: 100%;
      display: flex;
      align-items: center;
      position: fixed;
      bottom: 0;
      z-index: 11;
      & .uploader-wrapper {
        /* background-color: red; */
        height: 62px;
        width: 62px;
        right: 128px;
        /* bottom: 28px; */
        top: 50%;
        padding: 0 5px;
        margin-top: -26px;
        /* width: 100%; */
        position: absolute;
      }
      & .chat-input {
        width: 100%;
        min-height: 88px;
        max-height: 100%;
        /* height: 100% */
        border: none;
        /* padding: 0 30px; */
        padding: 0 190px 0 30px;
        font-size: 24px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
      }
      & img {
        position: absolute;
        padding: 10px;
      }
      & .pic-icon {
        height: 38px;
        width: 44px;
        /* right: 10px; */
        /* margin-right: 8px; */
      }
      & .gallery-img {
        height: 42px;
        width: 42px;
        position: absolute;
        right: 127px;
        opacity: 0;
        /* background-color: red; */
      }
      & .comment-icon {
        height: 40px;
        width: 40px;
        top: 50%;
        margin-top: -27px;
        right: 30px;
        padding: 10 5px;
        z-index: 20;
      }
    }
    & .pop-wrapper {
      /* van-pop css */
      border-radius: 10px;
      position: relative;
      top: 80px;
      /* top: 40%; */
    }
    & .pop-box {
      width: 600px;
      height: 700px;
      /* height: 40%; */
      background: rgba(255, 255, 253, 1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      /* justify-content: center; */
      align-items: center;
      /* position: absolute; */
      & .pop-icon {
        margin-top: 50px;
        & .doctor-icon {
          width: 120px;
          height: 120px;
        }
        & .doctor-box {
          margin-top: 14px;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          & .doctor-name {
            font-size: 30px;
            font-family: SourceHanSansCN-Bold;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          }
          & .famous {
            position: absolute;
            left: 120px;
            width: 48px;
            height: 28px;
          }
        }
      }
      & .pop-star {
        margin-top: 50px;
      }
      & .pop-comment {
        margin-top: 50px;
        & .comment-wrapper {
          display: flex;
          align-items: center;
          /* justify-content: space-around; */
          padding: 0 30px;
          box-sizing: border-box;
          flex-wrap: wrap;
          & .comment-item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            justify-content: center;
            margin-bottom: 30px;
            min-width: 160px;
            height: 50px;
            background: rgba(242, 242, 242, 1);
            border-radius: 25px;
            border-radius: 25px;
            font-size: 26px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
          & .activeComment {
            background: rgba(55, 189, 25, 1) !important;
            color: rgba(255, 255, 255, 1) !important;
          }
        }
      }
      & .pop-button {
        margin-top: 20px;
        position: relative;
        width: 188px;
        height: 60px;
        border: 1px solid rgba(55, 189, 25, 1);
        border-radius: 30px;
        background-color: #fffffd;
        font-size: 30px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        color: rgba(55, 189, 25, 1);
      }
    }
    & .pop-close {
      position: absolute;
      /* bottom: 300px; */
      top: 500px;
      right: 50%;
      margin-right: -30px;
      z-index: 9999;
      & .close-icon {
        width: 60px;
        height: 60px;
      }
    }
    & .comment-box {
      position: fixed;
      height: 100%;
      width: 100%;
      top: 0;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      & .pop-box {
        position: relative;
        margin-top: -300px;
      }
    }
    & #flag {
      /* height: 10px; */
      height: 100%;
      width: 100%;
      /* visibility: hidden; */
      /* padding-top: 50px; */
    }
    & .cancelActive {
      color: #9bd992 !important;
    }
    & .comment-button {
      box-shadow: 1px 8px 60px rgba(0, 0, 0, 0.1);
      width: 100%;
      height: 88px;
      position: fixed;
      bottom: 0;
      background: rgba(255, 255, 255, 1);
      font-size: 32px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      color: rgba(55, 189, 25, 1);
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shenduAskDoctor/SdAskChat.vue